import { render, staticRenderFns } from "./SideDrawerShopTheLook.vue?vue&type=template&id=53d4356c&scoped=true&lang=pug&"
import script from "./SideDrawerShopTheLook.vue?vue&type=script&lang=js&"
export * from "./SideDrawerShopTheLook.vue?vue&type=script&lang=js&"
import style0 from "./SideDrawerShopTheLook.vue?vue&type=style&index=0&id=53d4356c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4356c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d4356c')) {
      api.createRecord('53d4356c', component.options)
    } else {
      api.reload('53d4356c', component.options)
    }
    module.hot.accept("./SideDrawerShopTheLook.vue?vue&type=template&id=53d4356c&scoped=true&lang=pug&", function () {
      api.rerender('53d4356c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/SideDrawerShopTheLook.vue"
export default component.exports